<!-- <div class="navbar bg-[#FCFCFC] flex justify-between items-center p-2.5 px-10 border-b-2 border-[#DEE0E480]"> -->
<div class="navbar bg-tamiin-main-green flex justify-between items-center p-2.5 px-10 border-b-2 border-[#DEE0E480] text-white">
<div class="flex items-center flex-1 min-w-0 ">
    <div class="flex items-center gap-2 route-menu ">
      <i *ngIf="isMobileView" class="bx bx-sm" [ngClass]="sidebarService.isOpen() ? 'bx-menu-alt-right' : 'bx-menu'"
        (click)="sidebarService.toggle()" (keydown.enter)="sidebarService.toggle()" id="btn"></i>
     
    </div>

   <div
  *ngIf="(userRole$ | async) === 'insuree' || (userRole$ | async) === 'hmo' || (userRole$ | async) === 'nhia'"
  class="hidden md:flex items-center gap-2 min-w-0 overflow-hidden"
>

      <img
        src="https://static.vecteezy.com/system/resources/previews/027/425/828/large_2x/hmo-logo-design-inspiration-for-a-unique-identity-modern-elegance-and-creative-design-watermark-your-success-with-the-striking-this-logo-vector.jpg"
        alt="tamii hmo logo"
        class="h-[40px] w-[40px] rounded-full cursor-pointer border-2 border-[#DEE0E480] hover:border-[#4DCA62] transition-all duration-300 ease-in-out">
<span
  class="text-[16px] font-semibold
         truncate whitespace-nowrap overflow-hidden
         max-w-[180px] lg:max-w-[260px] flex-shrink"
  [title]="organizationName"
>{{ organizationName }}</span>
    </div>
  </div>
  <div class="relative profile">
    <div class="flex items-center gap-2 cursor-pointer profile_details">
      <!-- HMO Dropdown -->
      <div *ngIf="(userRole$ | async) ===  'insuree'" class="relative inline-block">
        <!-- HMO Icon -->
        <span class="material-symbols-outlined text-3xl mt-[6px] cursor-pointer" (click)="toggleHMODropdown()" (keydown.enter)="toggleHMODropdown()">
        local_hospital
      </span>

        <!-- Dropdown -->
        <div 
          *ngIf="homIsDropdownOpen" 
          class="absolute left-1/2 -translate-x-1/2 mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 z-50"
        >
        <!-- Heading -->
          <div class="px-4 py-2 border-b font-semibold text-gray-700 text-base">
            My HMO List
          </div>
          <ul *ngFor="let opt of options" class="divide-y divide-gray-100">
            <li (click)="selectOption(opt.value)" (keydown.enter)="selectOption(opt.value)" class="p-3 text-sm hover:bg-gray-50 cursor-pointer">{{ opt.label }}</li>
          </ul>
        </div>
      </div>
      <a [routerLink]="Notification">
        <img alt="Notification" src="/assets/icons/notification-bell.svg" class="cursor-pointer" />
      </a>

      <a [routerLink]="settings">
        <img alt="Settings" src="/assets/icons/settings.svg" class="cursor-pointer" />
      </a>
      <button *ngIf="profileImage" id="user-menu-button" [attr.aria-expanded]="isDropdownOpen"
        (click)="toggleDropdown()" class="cursor-pointer bg-none border-none p-0">
        <img [src]="profileImage" alt="User profile" />
      </button>
      <button *ngIf="!profileImage"
        class="initials-placeholder flex items-center justify-center h-[35px] w-[35px] rounded-full mr-2 text-[12px] font-bold text-[#f2f2fa] cursor-pointer"
         [style.background-color]="initialsBgColor"
  [style.color]="initialsTextColor" (click)="toggleDropdown()" type="button">
        {{ getInitials(userName) }}
      </button>
      <div *ngIf="!isSmallMobileView" class="profile_content text-[12px]" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()">
        <div class="font-bold name">{{ userName }}</div>
        <div class="designation">{{ displayRole }}</div>


      </div>
      <span class="material-symbols-outlined" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()">
        keyboard_arrow_down
      </span>
      <span class="sr-only">Open user menu</span>
    </div>

    <div *ngIf="isDropdownOpen"
      class="z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow-lg  absolute right-0 p-1 min-w-[200px]"
      id="user-dropdown" role="menu" aria-labelledby="user-menu-button" #userDropdown>

      <ul class="py-2">
        <li>
          <a href="#" role="menuitem"
            class="flex items-center block gap-2 px-4 py-2 text-sm text-black hover:bg-gray-100 hover:rounded"><i
              class="bx bx-cog text-[20px]"></i> Manage account</a>
        </li>
        <li>
          <a (click)="logOut()" role="menuitem"
            class="block px-4 py-2 text-sm text-[#F91111] cursor-pointer hover:bg-gray-100  flex gap-2 items-center">
            <span class="material-symbols-outlined text-[20px]"> logout </span>
            Sign out</a>
        </li>
      </ul>
    </div>
  </div>
</div>